// Marquee strip showing brand-promise lines
const items = [
  "Celebrate Big",
  "Open 24 × 7",
  "Since 1999",
  "Made in Gorakhpur",
  "56 flavours in one tub",
  "Bulk discounts",
  "Hand-folded daily",
];

export default function Marquee({ accent = "bg-holiday-red text-white" }) {
  const list = [...items, ...items];
  return (
    <div className={`relative overflow-hidden py-4 ${accent}`} data-testid="brand-marquee">
      <div className="marquee-track gap-12 whitespace-nowrap font-serif text-2xl italic">
        {list.map((t, i) => (
          <span key={i} className="flex items-center gap-12 shrink-0">
            {t}
            <span className="w-2 h-2 rounded-full bg-current opacity-60" />
          </span>
        ))}
      </div>
    </div>
  );
}

